import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { AnimatePresence, motion } from 'motion/react';

interface SelectionPillProps {
  count: number;
  onClear: () => void;
}

export const SelectionPill = ({ count, onClear }: SelectionPillProps) => {
  const { t } = useTranslation('drivers');
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className='-translate-x-1/2 -translate-y-14 fixed left-1/2 inline-flex items-center gap-4 rounded-md bg-primary-9 p-4 text-white shadow-md'
          aria-live='polite'
        >
          <div className='flex items-center gap-2'>
            <div className='flex size-6 items-center justify-center rounded-full bg-white'>
              <Typography variant='text-md-semibold' color='primary'>
                {count}
              </Typography>
            </div>
            <Typography variant='text-md-medium' color='white'>
              {t('face_id.selector.selection.count', { count })}
            </Typography>
          </div>
          <Button variant='ghost' size='sm' icon={<Icon name='x' />} className='text-white' aria-label={t('face_id.selector.selection.clear')} onClick={onClear} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SelectionPill;
